import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Quote } from "lucide-react";

const Testimonials = () => {
  const { t } = useLanguage();
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="bg-[#1e2a5a] text-[#f4f1ea] py-24 sm:py-32"
    >
      <span id="depoimentos" className="block -mt-24 pt-24" aria-hidden="true" />
      <span id="depoimentos-de-alunos" className="block -mt-24" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12">
        <div className="max-w-4xl">
          <h2 className="text-xs uppercase tracking-[0.22em] font-semibold text-[#e5b3b3]">
            {t.testimonials.seoH2}
          </h2>
          <p
            data-testid="testimonials-title"
            className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl tracking-tight whitespace-nowrap"
          >
            {t.testimonials.title}
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-px bg-[#2a3766]">
          {t.testimonials.items.map((item, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-[#1e2a5a] p-8 sm:p-10 flex flex-col"
            >
              <Quote className="h-6 w-6 text-[#d9381e]" strokeWidth={1.5} />
              <blockquote className="font-display italic mt-5 text-xl sm:text-2xl leading-snug text-[#f4f1ea]">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-[#34406d]">
                <div className="text-sm font-medium text-[#f4f1ea]">{item.name}</div>
                <div className="text-xs uppercase tracking-[0.18em] text-[#9a9a9a] mt-1">
                  {item.role}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
